import {ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {EmailListenerService} from "@app/shared-modal/email-modal/email-listener.service";
// import Intercom from '@intercom/messenger-js-sdk';
import {Subject, combineLatest, Subscription} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {EmailModalComponent} from "@app/shared-modal/email-modal/email-modal.component";
import {CsToastBoxService} from "@app/services";
import {AuthService} from "@app/core";

@Component({
  selector: 'app-shared-modal',
  templateUrl: './shared-modal.component.html',
  styles: []
})
export class SharedModalComponent implements OnInit, OnDestroy {

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    subscriptions: Subscription[] = [];
    aiModalCheck: boolean = false;

    constructor(
        private _emailEventService: EmailListenerService,
        private changeDetection: ChangeDetectorRef,
        private toast: CsToastBoxService,
        private authService: AuthService
    ) {
    }

  ngOnInit() {

    // Intercom({
    //   app_id: 'g31ttpil',
    //   hide_default_launcher: true
    // });

      const _combine = combineLatest(
          this._emailEventService.beforeSend$,
          this._emailEventService.afterSend$,
          this._emailEventService.send$
      )
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe(() => this.changeDetection.markForCheck());

      this.subscriptions.push(
          this._emailEventService.beforeSend$
              .pipe(takeUntil(this._unsubscribeAll))
              .subscribe((data: any) => {
                  this.toast.show('Your email is being sent', 4000);
              })
      );

      this.subscriptions.push(
          this._emailEventService.send$
              .pipe(takeUntil(this._unsubscribeAll))
              .subscribe((component: EmailModalComponent) => {
                  component.processEmail();
              })
      );
      this.subscriptions.push(_combine);
      this.aiModalCheck = this.authService.permitted(['SetupAICommunicationEmails.writeaccess']) === true;
  }


    @HostListener('window:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (event.key) {
            const key = event.key.toLowerCase();
            // Windows/Linux: Alt
            // Mac: Option is also "altKey", Command is "metaKey"
            const altOrOption = event.altKey;
            const cmd = event.metaKey;
            if ((altOrOption || cmd) && (key === 'h' || event.code === 'KeyH')) {
                event.preventDefault();
                if (this.aiModalCheck) {
                    this.triggerAidenModal();
                }
            }

            if ((altOrOption && key === 'c') || key === 'escape') {
                event.preventDefault();
                this.triggerAidenCancelButton();
            }
        }
    }


    triggerAidenModal() {
        const iframe = document.getElementById('email-template-message_ifr') as HTMLIFrameElement;
        const el = iframe.contentDocument.getElementById('aiden-modal-trigger');
        if (el) {
            el.dispatchEvent(new Event('click', { bubbles: true }));
            el.click();
        }
    }

    triggerAidenCancelButton() {
        // const iframe = document.getElementById('email-template-message_ifr') as HTMLIFrameElement;
        const el = document.getElementById('aiden-modal-cancel-button');
        if (el) {
            el.dispatchEvent(new Event('click', { bubbles: true }));
            el.click();
        }
    }


    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
    }

}
